import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../SessionManagement/AuthContext";
import {
  Container,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Snackbar,
  Alert,
  Backdrop,
} from "@mui/material";
import startImg from "../../assets/img/starter.png";
import professionalImg from "../../assets/img/professional.png";
import businessImg from "../../assets/img/business.png";
import EmailModal from "../EmailModal";
import useSharedLink from "../../SharedLink";
import { xorDecrypt } from "../../encrypt";
import axiosInstance from "../../api/axiosInstance";
// import axiosInstance from "../api/axiosInstance";

function PlanSelection() {
  const { state, dispatch } = useContext(AuthContext);
  const isAuthenticated =
    state.isAuthenticated || xorDecrypt(localStorage.getItem("username"));
  const navigate = useNavigate();
  const [prices, setPrices] = useState({
    ldbasicPrice: "",
    ldproPrice: "",
    hdbasicPrice: "",
    hdproPrice: "",
  });
  const [planType, setPlanType] = useState("lowerDoctor");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [countdownSnackbarOpen, setCountdownSnackbarOpen] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [countdown, setCountdown] = useState(3);
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const sharedLink = useSharedLink();

  useEffect(() => {
    axiosInstance
      .get(`${sharedLink}/config`, {
        withCredentials: true,
      })
      .then((response) => {
        const { ldbasicPrice, ldproPrice, hdbasicPrice, hdproPrice } =
          response.data;
        setPrices({ ldbasicPrice, ldproPrice, hdbasicPrice, hdproPrice });
      })
      .catch((error) => {
        console.error("Error fetching config:", error);
      });

    // if (localStorage.getItem("username")) {
    //   dispatch({
    //     type: "LOGIN",
    //     payload: { username: localStorage.getItem("username") },
    //   });
    // }
  }, []);

  const handleCheckout = (priceId) => {
    localStorage.removeItem("transactionStored");
    if (!isAuthenticated) {
      setSnackbarOpen(true);
      setBackdropOpen(true);
      return;
    }
    const email = xorDecrypt(localStorage.getItem("username"));
    axiosInstance
      .post(
        `${sharedLink}/create-checkout-session`,
        { priceId, email },
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        window.location.href = response.data.url;
      })
      .catch((error) => {
        console.error("Error creating checkout session:", error);
        document.getElementById("error-message").innerText =
          "Error creating checkout session. Please try again.";
      });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setCountdownSnackbarOpen(true);
    const interval = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown === 1) {
          clearInterval(interval);
          setBackdropOpen(false);
          navigate("/login");
        }
        return prevCountdown - 1;
      });
    }, 1000);
  };

  const handleCountdownSnackbarClose = () => {
    setCountdownSnackbarOpen(false);
    setBackdropOpen(false);
  };

  const handleChange = (event) => {
    setPlanType(event.target.value);
  };

  const handleEmailModalOpen = () => {
    setEmailModalOpen(true);
  };

  const handleEmailModalClose = () => {
    setEmailModalOpen(false);
  };

  return (
    <Box
      sx={{
        backgroundImage:
          'url("https://www.example.com/your-background-image.jpg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        py: 8,
      }}
    >
      <Container>
        <Box sx={{ mb: 4 }}>
          <FormControl fullWidth>
            <InputLabel id="plan-type-label">Plan Type</InputLabel>
            <Select
              labelId="plan-type-label"
              id="plan-type-select"
              value={planType}
              label="Plan Type"
              onChange={handleChange}
            >
              <MenuItem value="lowerDoctor">Lower Doctor</MenuItem>
              <MenuItem value="higherDoctor">Higher Doctor</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Typography variant="h4" component="h1" gutterBottom>
          Choose a collaboration plan
        </Typography>
        <Grid container spacing={4}>
          {planType === "lowerDoctor" && (
            <>
              <Grid item xs={12} md={4}>
                <Card onClick={() => handleCheckout(prices.ldbasicPrice)}>
                  <CardMedia
                    component="img"
                    height="140"
                    image={startImg}
                    alt="Starter"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      Starter
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      $12 per month
                    </Typography>
                    <Button variant="contained" color="primary">
                      Select
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={4}>
                <Card onClick={() => handleCheckout(prices.ldproPrice)}>
                  <CardMedia
                    component="img"
                    height="140"
                    image={professionalImg}
                    alt="Professional"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      Professional
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      $15 per month
                    </Typography>
                    <Button variant="contained" color="primary">
                      Select
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={4}>
                <Card>
                  <CardMedia
                    component="img"
                    height="140"
                    image={businessImg}
                    alt="Business"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      Business
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Contact us for pricing
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleEmailModalOpen}
                    >
                      Contact Us
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            </>
          )}
          {planType === "higherDoctor" && (
            <>
              <Grid item xs={12} md={4}>
                <Card onClick={() => handleCheckout(prices.hdbasicPrice)}>
                  <CardMedia
                    component="img"
                    height="140"
                    image={startImg}
                    alt="Starter"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      Starter
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      $20 per month
                    </Typography>
                    <Button variant="contained" color="primary">
                      Select
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={4}>
                <Card onClick={() => handleCheckout(prices.hdproPrice)}>
                  <CardMedia
                    component="img"
                    height="140"
                    image={professionalImg}
                    alt="Professional"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      Professional
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      $25 per month
                    </Typography>
                    <Button variant="contained" color="primary">
                      Select
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={4}>
                <Card>
                  <CardMedia
                    component="img"
                    height="140"
                    image={businessImg}
                    alt="Business"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      Business
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Contact us for pricing
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleEmailModalOpen}
                    >
                      Contact Us
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            </>
          )}
        </Grid>
        <div id="error-message" className="error-message"></div>

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={2000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert onClose={handleSnackbarClose} severity="error">
            Please login to proceed...
          </Alert>
        </Snackbar>

        <Snackbar
          open={countdownSnackbarOpen}
          autoHideDuration={3000}
          onClose={handleCountdownSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert onClose={handleCountdownSnackbarClose} severity="error">
            Redirecting you to the login page in {countdown}...
          </Alert>
        </Snackbar>

        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={backdropOpen}
        />
      </Container>

      <EmailModal open={emailModalOpen} handleClose={handleEmailModalClose} />
    </Box>
  );
}

export default PlanSelection;
